module.exports = __webpack_public_path__ + "img/welcome.a4afc104.svg";